module.exports = __webpack_public_path__ + "static/media/play.67019807.svg";